export interface AppConfig {
  oidc: {
    authority: string;
    clientId: string;
    redirectUrl: string;
    postLogoutRedirectUri: string;
    scope: string;
  };
  api: {
    middlewareUrl: string;
    navvisUrl: string;
  };
  defaultNavvisSiteId: number;
}

let _config: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  const resp = await fetch('/assets/config.json');
  if (!resp.ok) {
    throw new Error(`Failed to load config.json: ${resp.status} ${resp.statusText}`);
  }
  const raw = await resp.json();
  _config = {
    oidc: {
      authority: raw['OIDC.Authority'],
      clientId: raw['OIDC.ClientId'],
      redirectUrl: raw['OIDC.ReturnUri'],
      postLogoutRedirectUri: raw['OIDC.PostLogoutRedirectUri'],
      scope: raw['OIDC.Scope'],
    },
    api: {
      middlewareUrl: raw['API.MiddlewareUrl'],
      navvisUrl: raw['API.NavvisUrl'],
    },
    defaultNavvisSiteId: raw['DefaultNavvisSiteId'],
  };
  return _config!;
}

export function getConfig(): AppConfig {
  if (!_config) throw new Error('Config not loaded — call loadConfig() first');
  return _config;
}
